import { render, staticRenderFns } from "./ProjectHero.vue?vue&type=template&id=7cc67dc4&"
import script from "./ProjectHero.vue?vue&type=script&lang=js&"
export * from "./ProjectHero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports